<template lang="pug">
  .card-loading-module
    .loading-block
      .card-list-item(v-for="(item,index) in cardList" :key="index")
        .card-line-one
        .card-line-two
        .card-line-three
        .card-line-button
</template>
<script>
export default {
  data() {
    return {
      cardList: [1, 2, 3, 4, 5],
    };
  },
};
</script>
<style lang="less" scoped>
.loading-block {
  height: 100%;
  padding: 0.13rem 0.12rem 0 0.12rem;

  .card-list-item {
    width: 100%;
    height: 0.93rem;
    background: #fff;
    border-radius: 0.16rem;
    padding: 0.12rem 0.15rem;
    margin-bottom: 0.08rem;
    position: relative;

    .card-line-one,
    .card-line-button {
      position: relative;
      overflow: hidden;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background:
          linear-gradient(
            104deg,
            rgba(255, 255, 255, 0) 13.78%,
            #fff 53.27%,
            rgba(255, 255, 255, 0) 90.04%
          );
        animation: move-light 1.5s both infinite;
      }
    }

    .card-line-one {
      width: 2.02rem;
      height: 0.24rem;
      background: #d3dae0;
      margin-bottom: 0.08rem;
      border-radius: 0.12rem;
      opacity: 0.5;
    }

    .card-line-two {
      width: 1.28rem;
      height: 0.16rem;
      background-color: #d3dae0;
      border-radius: 0.12rem;
      opacity: 0.2;
      margin-bottom: 0.06rem;
    }

    .card-line-three {
      width: 1.28rem;
      height: 0.16rem;
      background-color: #d3dae0;
      border-radius: 0.12rem;
      opacity: 0.2;
    }

    .card-line-button {
      position: absolute;
      bottom: 0.14rem;
      right: 0.15rem;
      width: 0.5rem;
      height: 0.22rem;
      border-radius: 0.2rem;
      background-color: #d3dae0;
    }
  }
}

@keyframes move-light {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}
</style>
